module.exports = __webpack_public_path__ + "static/img/pay.e08a847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pay.png
// module id = ymQl
// module chunks = 1